import { headerAuthorization } from '../../../shared/helpers/localstorage-helper';
import { User } from '../../../shared/types/user';
import { BASE_URL } from '../../../shared/consts/variables';

export const getMe = async (): Promise<User> => {
    const response = await fetch(`${BASE_URL}/users/me`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        }
    });

    if (!response.ok) {
        const data = await response.json();
        const error = new Error(data.message || 'Erro ao buscar dados do usuário') as Error & {
            status?: number;
            code?: string;
        };

        error.status = response.status;
        error.code = data.code;
        throw error;
    }

    return response.json();
};

export const postUser = async (user: User): Promise<User> => {
    const response = await fetch(`${BASE_URL}/users`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        },
        body: JSON.stringify(user)
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao criar usuário');
    }

    return response.json();
};

export const deleteUser = async (id: string): Promise<User> => {
    const response = await fetch(`${BASE_URL}/users/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao deletar usuário');
    }

    return response.json();
};

export const deleteUsersBulk = async (ids: string[]): Promise<{ message: string; deletedCount: number }> => {
    const response = await fetch(`${BASE_URL}/users/bulk`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        },
        body: JSON.stringify({ ids })
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao deletar usuários');
    }

    return response.json();
};

export const updateUser = async (id: string, user: User): Promise<User> => {
    const response = await fetch(`${BASE_URL}/users/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        },
        body: JSON.stringify(user)
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao atualizar usuário');
    }

    return response.json();
};

export const getUsers = async (companyId?: string): Promise<User[]> => {
    const queryParams = new URLSearchParams();

    if (companyId) {
        queryParams.append('companyId', companyId);
    }

    const url = queryParams.toString()
        ? `${BASE_URL}/users?${queryParams.toString()}`
        : `${BASE_URL}/users`;

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar dados do usuário');
    }

    return response.json();
};

export const getUserById = async (id: string): Promise<User | null> => {
    const response = await fetch(`${BASE_URL}/users/${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar dados do usuário');
    }

    return response.json();
};

export const getUserByEmail = async (email: string): Promise<User | null> => {
    const response = await fetch(`${BASE_URL}/users/email`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar dados do usuário');
    }

    return response.json();
};


export const changePasswordAfterFirstLogin = async (email: string, newPassword: string, oldPassword: string): Promise<User> => {
    const response = await fetch(`${BASE_URL}/users/change-password`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, newPassword, oldPassword })
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao atualizar senha do usuário');
    }

    return response.json();
};
